/* clown-preview-link-persistence.js
   When the page is viewed via Shopify theme preview (?preview_theme_id=X),
   the param gets dropped on internal navigation, sending the user back to
   the live theme. This script propagates the preview_theme_id to every
   same-origin link + form action so the whole site stays in preview mode
   while sharing the URL with stakeholders. */
(function () {
  var params = new URLSearchParams(window.location.search);
  var previewId = params.get('preview_theme_id');
  var previewKey = params.get('_fd') || params.get('pb') || params.get('key');
  if (!previewId) return;

  var origin = window.location.origin;

  function shouldSkip(href) {
    if (!href) return true;
    var lower = href.toLowerCase();
    if (lower[0] === '#') return true;
    if (lower.indexOf('mailto:') === 0) return true;
    if (lower.indexOf('tel:') === 0) return true;
    if (lower.indexOf('javascript:') === 0) return true;
    if (lower.indexOf('data:') === 0) return true;
    return false;
  }

  function inject(url) {
    try {
      var u = new URL(url, origin);
      if (u.origin !== origin) return url;
      if (!u.searchParams.has('preview_theme_id')) {
        u.searchParams.set('preview_theme_id', previewId);
      }
      if (previewKey && !u.searchParams.has('_fd') && !u.searchParams.has('pb') && !u.searchParams.has('key')) {
        u.searchParams.set('_fd', previewKey);
      }
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function patch(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('a[href]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (shouldSkip(href)) return;
      if (a.dataset.previewPatched === '1') return;
      var resolved = a.href;
      var next = inject(resolved);
      if (next !== resolved) a.href = next;
      a.dataset.previewPatched = '1';
    });
    root.querySelectorAll('form[action]').forEach(function (f) {
      var action = f.getAttribute('action');
      if (!action) return;
      if (f.dataset.previewPatched === '1') return;
      var resolved = f.action;
      var next = inject(resolved);
      if (next !== resolved) f.action = next;
      f.dataset.previewPatched = '1';
    });
  }

  function run() {
    patch(document);
    if (!('MutationObserver' in window)) return;
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) patch(added[j]);
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
